export default __webpack_public_path__ + "static/media/zoom-out.9d6afdc5.svg";